export interface InvestmentChartConfig {
  category: InvestmentChartCatergory;
  label: string;
  color: string;
  borderRadius: number[];
}

export enum InvestmentChartCatergory {
  INVESTMENT = 0,
  VALUE_APPRECIATION = 1,
  RENTAL_INCOME = 2,
}
